<script lang="ts">
  import type { Asset, Richtext } from '@storyblok-types';
  import clsx from 'clsx';
  import { backgrounds, type PageSectionBackground } from '@athena-lib/container-context.svelte';
  import ImageOrVideo from '../ImageOrVideo.svelte';
  import { alignClasses, type Alignment } from '../shared/page-section-utils';
  import { RichText } from '../../RichText';
  import { isRichTextEmpty } from '../../RichText/types';
  import { getFocalPointClasses } from '../shared/image-utils';

  const boxPadding = {
    none: 'p-0',
    small: 'p-4',
    medium: 'p-8',
    large: 'p-12',
  };

  const {
    asset,
    zoomOnHover,
    fit,
    padding,
    description,
    imageBoxColor,
    mobileItemTextAlignment,
    desktopItemTextAlignment,
  }: {
    asset: Asset | undefined;
    description: Richtext | string | undefined;
    fit: 'contain' | 'cover';
    padding: keyof typeof boxPadding | undefined;
    zoomOnHover: boolean;
    imageBoxColor: PageSectionBackground | undefined;
    mobileItemTextAlignment: Alignment | undefined;
    desktopItemTextAlignment: Alignment | undefined;
  } = $props();
  const shouldZoomOnHover = $derived(
    zoomOnHover && 'transition-transform duration-[1500ms] ease-in-out hover:scale-125',
  );

  const getFitClasses = (fit: 'contain' | 'cover') => {
    return fit == 'cover'
      ? 'object-cover aspect-square w-full h-full'
      : 'object-contain aspect-square';
  };
</script>

{#if asset}
  <div
    class={clsx(
      'mb-4 flex aspect-square w-full items-center justify-center',
      imageBoxColor ? backgrounds[imageBoxColor] : '',
    )}
  >
    <div
      class={clsx(
        'flex aspect-square items-center justify-center overflow-clip',
        boxPadding[padding ?? 'none'],
      )}
    >
      <ImageOrVideo
        {asset}
        class={clsx('mx-auto block max-h-full max-w-full', shouldZoomOnHover)}
        innerImageClass={clsx(getFitClasses(fit), getFocalPointClasses(asset))}
        videoClass={getFitClasses(fit)}
      />
    </div>
  </div>

  {#if (typeof description === 'string' && description.trim()) || (typeof description !== 'string' && !isRichTextEmpty(description))}
    <div
      class={clsx(
        alignClasses['mobile'][mobileItemTextAlignment ?? 'left'],
        alignClasses['desktop'][desktopItemTextAlignment ?? 'left'],
      )}
    >
      {#if typeof description === 'string'}
        {description}
      {:else}
        <RichText text={description} />
      {/if}
    </div>
  {/if}
{/if}
